// src/GlobalFont.tsx
import { Global } from '@emotion/react';
import regularFont from './../public/fonts/HerbalifeNatural-Regular.otf';
import boldFont from './../public/fonts/HerbalifeNatural-Bold.otf';
import lightFont from './../public/fonts/HerbalifeNatural-Light.otf';


const GlobalFont = () => (
  <Global
styles={`
      @font-face {
        font-family: 'HerbalifeFont';
        src: url(${lightFont}) format('opentype');
        font-weight: 300;
      }

      @font-face {
        font-family: 'HerbalifeFont';
        src: url(${regularFont}) format('opentype');
        font-weight: 400;
      }

      @font-face {
        font-family: 'HerbalifeFont';
        src: url(${boldFont}) format('opentype');
        font-weight: 700;
      }

      body {
        font-family: 'HerbalifeFont', sans-serif;
      }
    `}
  />
);

export default GlobalFont;
